import { Modal } from "antd";

// Shared "you have unsaved changes" guard used when navigating away from a
// listings profile section/tab that has pending edits. Runs `onLeave` only if
// the user confirms they're ok losing the changes.
export function confirmDiscardUnsaved(onLeave: () => void, onStay?: () => void) {
  Modal.confirm({
    title: "Unsaved changes",
    content: "You have unsaved changes that might be lost if you leave. Do you want to continue?",
    okText: "Leave",
    cancelText: "Stay",
    okButtonProps: { danger: true },
    onOk: onLeave,
    onCancel: onStay,
  });
}
